<!--地图轨迹过滤器-->
<template>
  <div class='uk-flex w-100'>
    <div class='w-100'>
      <el-select v-model='traceSearchForm.option' :placeholder="$t('public.please')" style='width: 100%'>
        <el-option v-for='(item, index) in filterOptionList' :key='index' :label='item.name'
                   :value='item.content'></el-option>
      </el-select>
      <el-form class='uk-margin-small-top' :model='speed' :rules='rules' ref='speed' :show-message='false'
               v-if="traceSearchForm.option === 'filter_speed'" label-position='left'>
        <!-- 区间下拉选择 -->
        <el-form-item>
          <el-select v-model='condition'>
            <el-option :label="$t('home.range')" :value="'range'"></el-option>
            <el-option :label="$t('home.greater')" :value="'greater'"></el-option>
            <el-option :label="$t('home.less')" :value="'less'"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <div class='uk-flex uk-flex-middle  filter-speed'>
            <!-- 区间 -->
            <template v-if="condition === 'range'">
              <el-form-item prop='less'>
                <el-input v-model='speed.less'></el-input>
              </el-form-item>
              <el-form-item>
                <div class='to'>To</div>
              </el-form-item>
              <el-form-item prop='greater'>
                <el-input v-model='speed.greater'></el-input>
              </el-form-item>
              <el-form-item>
                <span class='uk-margin-small-left'>km/s</span>
              </el-form-item>
            </template>

            <template v-else-if="condition === 'greater'">
              <el-form-item prop='less'>
                <el-input v-model='speed.less'></el-input>
              </el-form-item>
              <el-form-item>
                <span class='uk-margin-small-left'>km/s</span>
              </el-form-item>
            </template>

            <template v-else-if="condition === 'less'">
              <el-form-item prop='greater'>
                <el-input v-model='speed.greater'></el-input>
              </el-form-item>
              <el-form-item>
                <span class='uk-margin-small-left'>km/s</span>
              </el-form-item>
            </template>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <el-button type='primary' @click='emitFilter'>{{ $t('过滤') }}</el-button>
  </div>
</template>
<script>

export default {
  props: {
    filterOptionList: {}
  },
  data () {
    return {
      condition: 'range',
      traceSearchForm: {
        from: null,
        to: null,
        option: 'filter_none'
      },
      // 速度过滤器
      speed: {
        greater: 120,
        less: 60
      }
    }
  },
  computed: {
    rules () {
      const dateValidator = (rules, value, callback) => {
        const from = this.traceSearchForm.from
        const to = this.traceSearchForm.to

        if (from && to && from instanceof Date && to instanceof Date) {
          if (from.getTime() > to.getTime()) return callback(new Error($t('integration.start_date_cannot_be_later_than_end_date')))
          return callback()
        }
        return callback()
      }
      const speedValidator = (rules, value, callback) => {
        const left = parseFloat(this.speed.less)
        const right = parseFloat(this.speed.greater)
        if (left && right) {
          if (left > right) {
            return callback(new Error($t('integration.the_left_section_cannot_be_greater_than_the_right_section')))
          }
          return callback()
        }
        return callback()
      }
      return {
        from: [{
          trigger: 'change',
          validator: dateValidator
        }],
        to: [{
          trigger: 'change',
          validator: dateValidator
        }],
        less: [{
          trigger: 'change',
          validator: speedValidator
        }],
        greater: [{
          trigger: 'change',
          validator: speedValidator
        }]
      }
    }
  },
  watch: {
    // 速度筛选条件
    condition: {
      handler (newVal) {
        switch (newVal) {
          case 'range':
            this.speed = {
              less: 60,
              greater: 120
            }
            break
          case 'greater':
            this.speed = {
              less: 60,
              greater: undefined
            }
            break
          case 'less':
            this.speed = {
              less: undefined,
              greater: 120
            }
        }
      }
    }
  },
  methods: {
    emitFilter () {
      this.$emit('onFilter', {
        option: this.traceSearchForm.option,
        speed: this.traceSearchForm.option === 'filter_speed' ? this.speed : null
      })
    }
  }
}
</script>

<style scoped lang='scss'>
// 速度筛选器
.filter-speed {
  .to {
    width: 50px;
    text-align: center;
    border-top: #ccc solid 1px;
    border-bottom: #ccc solid 1px;
  }

  ::v-deep .el-input {
    width: 70px;
  }
}

::v-deep .el-form-item {
  margin-bottom: 0;
}
</style>
